module.exports = __webpack_public_path__ + "img/ai.2e0dca25.svg";